import axios from "axios";

const saveRegionApiPg = async (body) => {
  const token = localStorage.getItem("token");
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_URL_BACKEND}api/v1/region`,
      body,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    const data = await res.data;
    return { data, res };
  } catch (error) {
    console.error(error);
  }
};

export default saveRegionApiPg;
